export default __webpack_public_path__ + "static/media/FAMILY_CASE_RIGHT_IMG.bca6ee27.png";